import { API } from '@constants'

export * from './suiteAvailabilityContent'

// Resort constants
export const KIND_RESORT = 'resort'
export const API_RESORT_LOVE_START = `${API}/form/resortLoveStart`
export const API_RESORT = (brandCode: string, resortKey: string) => `${API}/resort/${resortKey}?brand=${brandCode}`
export const API_RESORTS = (brandCode: string) => `${API}/resort?brand=${brandCode}`
export const API_RESORT_NAMES = `${API}/resortsNames`
export const MK_RESORTS_PATH = '/stays/resorts'
export const VIEW_AVAILABILITY = 'View Availability'
export const MONTHLY_AVAILABILITY_PATH = '/resort-monthly-calendar/'
export const MONTHLY_AVAILABILITY_TEXT = 'View Monthly Availability And Waitlist'
export const LOADING_AVAILABILITY_MESSAGE = 'Loading Availability. Please wait while we fetch the latest availability information.'
export const COMING_SOON_PATH = '/comingSoon'
